/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import { DOCUMENTS } from "@/src/services/globalVars";
import _get from "lodash/get";
import { getCaseLink } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type DocumentPaidProps = {
  product: AbstractCase;
  isFreeOrder?: boolean;
};

const DocumentPaid = ({ isFreeOrder = false, product }: DocumentPaidProps) => {
  const translate = (path: string) => {
    return _get(DOCUMENTS, path);
  };

  return (
    <>
      <p>
        {product.checkoutItem.id === 6 ? (
          <>
            Sie können sich nun eine tabellarische Berechnung sowie ein Analysedokument herunterladen. Sie finden die Dokumente jederzeit in Ihrer Servicewelt
            unter “Dokumente”.
          </>
        ) : (
          <>
            Sie können sich nun {translate(product.name + ".titlePossessive")} herunterladen. Sie finden das Dokument jederzeit in Ihrer Servicewelt unter
            “Dokumente”.
          </>
        )}

        {!isFreeOrder && " Zudem erhalten Sie per E-Mail eine Zahlbestätigung und Ihre Rechnung."}
      </p>
      <Button fullWidth variant={"contained"} color="primary" component={Link} to={getCaseLink(product)}>
        {product.checkoutItem.id === 6 ? "Zu meinen Dokumenten" : "Zu meinem Dokument"}
      </Button>
    </>
  );
};

export default DocumentPaid;
